module.exports = __webpack_public_path__ + "img/holiday-empty-image.319f3488.webp";